export { default } from './ObservationPhoto.components';
